import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import '../../queries/book-appointment.js';
import '../../queries/get-calendar-availability.js';
import '../../queries/get-time-slots.js';
import { GET_STORE_OFFER_BY_CODE } from '../../queries/get-store-offer-by-code.js';
import '../../queries/get-user.js';
import '../../queries/get-store-opening-times.js';
import '../../queries/get-availability-stores-nearby.js';
import { fromStoreOfferQueryToStore } from './adapters/fromStoreOfferQueryToStore.js';
import '@grandvisionhq/stores-v2';

const useStoreOfferByCode = (variables)=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_STORE_OFFER_BY_CODE, {
        variables,
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        }
    });
    const data = React.useMemo(()=>{
        var ref;
        return ((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.store) ? fromStoreOfferQueryToStore(queryState.data.store) : null;
    }, [
        queryState
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            }), 
        ]
    , [
        data,
        queryState,
        query
    ]);
};

export { useStoreOfferByCode as default };
//# sourceMappingURL=use-store-offer-by-code.js.map
